import React from "react";
import {
  Dimensions,
  FlatList,
  Platform,
  SafeAreaView,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import ChoosePolicyListItem from "./ChoosePolicyListItem";
import { useAppSelector } from "@lib";
import { PolicyType } from "@lib";
import { ScreenNameList } from "@lib/utilities/Constants";
import { ids, styles } from "./style";
import { isTablet } from "react-native-device-info";

const PolicyList = ({
  handlePolicySelection,
  showAlerts,
  isLoading,
}: {
  handlePolicySelection: (policyDoc: PolicyType) => void;
  showAlerts: boolean;
  isLoading: boolean;
}) => {
  const { height, width } = useWindowDimensions();
  const policyList = useAppSelector((state) => state?.policyReducer.policies);
  const isConnected = useAppSelector(
    (state) => state?.userReducer?.isConnected,
  );

  const getOrientationStyles = (isFlatlist?: boolean) => {
    if (isFlatlist) {
      return {
        width: height > width ? width : height,
      };
    }
    return {
      marginTop: Platform.select({
        ios: isTablet() ? (height > width ? "14%" : "10%") : "30%",
        android: isTablet()
          ? height > width
            ? height * 0.08
            : height * 0.12
          : "20%",
      }),
    };
  };
  return (
    <View style={[styles.mainContainer]}>
      {(isConnected || showAlerts) && (
        <>
          {policyList.length > 0 && !isLoading && (
            <Text
              style={[styles.heading, { ...getOrientationStyles() }]}
              dataSet={{ media: ids.heading }}
              testID={`policy-listing-header`}
            >
              {ScreenNameList.choosePolicy}
            </Text>
          )}
          <FlatList
            contentContainerStyle={styles.containerStyle}
            bounces={false}
            showsVerticalScrollIndicator={false}
            data={policyList}
            keyExtractor={(_, index) => `policy-${index}`}
            renderItem={({ item }) => (
              <ChoosePolicyListItem
                policyData={item}
                onItemPress={() => handlePolicySelection(item)}
              />
            )}
          />
        </>
      )}
    </View>
  );
};

export default PolicyList;
